// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/base.css'
import 'lib-flexible/flexible'
import 'normalize.css/normalize.css'


import axios from 'axios';

//上线的时候需要修改的地方  -----  register.vue文件的验证码图片地址
axios.defaults.baseURL = 'http://live.vaneqi.cn/liv'   //上线的时候修改跨域代理
Vue.prototype.baseURL = 'http://live.vaneqi.cn/liv'
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;

//请求拦截器
// axios.interceptors.request.use(config => {
//   console.log(config);
// })

import { Toast } from 'vant';
Vue.use(Toast);
Vue.use(Vant);



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js